var exports = {
  "R": "FriendsList.module__friendsListContainer___NnE5RH",
  "X": "FriendsList.module__scroller___NnE5RH",
};

module.exports = exports;
